import {
  isPlainObject, toLower, pickBy, map, isFinite,
} from 'lodash';
import eventHelpers from '@/services/helpers/event';
import Event from './event';

const SoccerPlayer = (player) => {
  if (!isPlainObject(player)) return null;

  return {
    playerId: player?.playerId,
    playerIndex: player?.playerIndex,
    /* name: player?.player?.personalInfo?.name || '', */
    position: player?.position,
    goals: player?.playerStats?.goals || 0,
    goalsFromPenalty: player?.playerStats?.goalsFromPenalty || 0,
    ownGoals: player?.playerStats?.ownGoals || 0,
    yellowCards: player?.playerStats?.yellowCards || 0,
    redCards: player?.playerStats?.redCards || 0,
    startsOnPitch: player?.playerStats?.startsOnPitch || false,
    state: player?.playerStats?.state || 'N_A',
    offsides: player?.playerStats?.offsides || 0,
    assists: player?.playerStats?.assists || 0,
    accuratePasses: player?.playerStats?.accuratePasses || 0,
    totalPasses: player?.playerStats?.totalPasses || 0,
    accurateCrosses: player?.playerStats?.accurateCrosses || 0,
    totalCrosses: player?.playerStats?.totalCrosses || 0,
    tackles: player?.playerStats?.tackles || 0,
    interceptions: player?.playerStats?.interceptions || 0,
    saves: player?.playerStats?.saves || 0,
    totalShots: player?.playerStats?.totalShots || 0,
    totalShotsOnTarget: player?.playerStats?.totalShotsOnTarget || 0,
  };
};

/* const SoccerIncident = (incident) => {
  if (!isPlainObject(incident)) return null;

  return {
    type: incident?.type || '',
    playerId: incident?.playerId || '',
    period: incident?.period || 'N_A',
    elapsedSecondInPeriod: incident?.elapsedSecondInPeriod || 0,
    isConfirmed: incident?.isConfirmed || false,
    ownGoal: incident?.ownGoal || false,
    penalty: incident?.penalty || false,
    playerIdIn: incident?.playerIdIn || '',
    playerIdOut: incident?.playerIdOut || '',
  };
}; */

const SoccerPerPeriod = (perPeriod, { side }) => pickBy(
  {
    IN_FIRST_HALF: perPeriod?.IN_FIRST_HALF?.[side],
    IN_SECOND_HALF: perPeriod?.IN_SECOND_HALF?.[side],
    IN_EXTRATIME_FIRST_HALF: perPeriod?.IN_EXTRATIME_FIRST_HALF?.[side],
    IN_EXTRATIME_SECOND_HALF: perPeriod?.IN_EXTRATIME_SECOND_HALF?.[side],
    IN_PENALTY_SHOOTOUTS: perPeriod?.IN_PENALTY_SHOOTOUTS?.[side],
  },
  isFinite,
);

const SoccerCompetitor = (event, { side, details }) => {
  const competitor = event?.[toLower(side)];
  if (!isPlainObject(competitor)) return null;

  return {
    ...competitor,
    score: details?.[`${toLower(side)}Score`] || 0,
    regularTimeScore: details?.[`${toLower(side)}ScoreRegularTime`] || 0,
    penaltiesScore: details?.[`${toLower(side)}ScorePenaltyShootout`],
    firstLegScore: details?.[`${toLower(side)}ScoreFirstLeg`] || 0,
    scorePerPeriod: SoccerPerPeriod(details?.scorePerPeriod, { side }),
    lineup: map(details?.[`${toLower(side)}Lineup`] || [], SoccerPlayer),
    yellowCards: details?.yellowCardsInMatch?.[side] || 0,
    yellowCardsPerPeriod: SoccerPerPeriod(details?.yellowCardsPerPeriod, { side }),
    redCards: details?.redCardsInMatch?.[side] || 0,
    redCardsPerPeriod: SoccerPerPeriod(details?.redCardsPerPeriod, { side }),
    corners: details?.cornersInMatch?.[side] || 0,
    cornersPerPeriod: SoccerPerPeriod(details?.cornersPerPeriod, { side }),
    fouls: details?.foulsInMatch?.[side] || 0,
    foulsPerPeriod: SoccerPerPeriod(details?.foulsPerPeriod, { side }),
    shotsOnTarget: details?.shotsOnTargetInMatch?.[side] || 0,
    shotsOnTargetPerPeriod: SoccerPerPeriod(details?.shotsOnTargetPerPeriod, { side }),
    shotsOffTarget: details?.shotsOffTargetInMatch?.[side] || 0,
    shotsOffTargetPerPeriod: SoccerPerPeriod(details?.shotsOffTargetPerPeriod, { side }),
    freeKicks: details?.freeKicksInMatch?.[side] || 0,
    freeKicksPerPeriod: SoccerPerPeriod(details?.freeKicksPerPeriod, { side }),
    penalties: details?.penaltiesInMatch?.[side] || 0,
    penaltiesPerPeriod: SoccerPerPeriod(details?.penaltiesPerPeriod, { side }),
    attacks: details?.attacksInMatch?.[side] || 0,
    attacksPerPeriod: SoccerPerPeriod(details?.attacksPerPeriod, { side }),
    dangerousAttacks: details?.dangerousAttacksInMatch?.[side] || 0,
    dangerousAttacksPerPeriod: SoccerPerPeriod(details?.dangerousAttacksPerPeriod, { side }),
    ownGoalsPerPeriod: SoccerPerPeriod(details?.ownGoalsPerPeriod, { side }),
    goalsFromPenaltyPerPeriod: SoccerPerPeriod(details?.goalsFromPenaltyPerPeriod, { side }),
    offsidesPerPeriod: SoccerPerPeriod(details?.offsidesPerPeriod, { side }),
    ownGoals: details?.ownGoalsInMatch?.[side] || 0,
    goalsFromPenalty: details?.goalsFromPenaltyInMatch?.[side] || 0,
    offsides: details?.offsidesInMatch?.[side] || 0,
    assists: details?.assistsInMatch?.[side] || 0,
    accuratePasses: details?.accuratePassesInMatch?.[side] || 0,
    totalPasses: details?.totalPassesInMatch?.[side] || 0,
    accurateCrosses: details?.accurateCrossesInMatch?.[side] || 0,
    totalCrosses: details?.totalCrossesInMatch?.[side] || 0,
    tackles: details?.tacklesInMatch?.[side] || 0,
    interceptions: details?.interceptionsInMatch?.[side] || 0,
    saves: details?.savesInMatch?.[side] || 0,
  };
};

export default (data, selectedFeed) => {
  if (!isPlainObject(data)) return null;
  const event = Event(data, selectedFeed);
  const details = eventHelpers.findEventDetails(data, selectedFeed);

  return {
    ...event,
    period: details?.period || 'N_A',
    injuryTimeDuration: details?.injuryTimeDuration || 0,
    injuryTimeDurationOfficial: details?.injuryTimeDurationOfficial || false,
    isSecondLeg: details?.secondLeg || false,
    extraTimeHalfDuration: details?.extraTimeHalfDuration || 0,
    maxSubstitutions: details?.maxsubstitutions || 0,
    halfDuration: details?.halfDuration || 0,
    elapsedSecondInPeriod: details?.elapsedSecondInPeriod || 0,
    home: SoccerCompetitor(event, { side: 'HOME', details }),
    away: SoccerCompetitor(event, { side: 'AWAY', details }),
    inBreak: details?.eventInBreak,
    inPrematch: details?.eventPreMatch,
    actions: details?.actions ?? [],
    riskFlags: details?.riskFlags || [],
    homeLineup: details?.homeLineup || [],
    awayLineup: details?.awayLineup || [],
    hydrationBreakInProgress: details?.hydrationBreakInProgress,
    hydrationBreakStartTime: details?.hydrationBreakStartTime,
  };
};
